//Action Creators for Analyitcs Site
import axios from 'axios';


const testDataAPI = [
    {
        "dateInstance": "2024-08-01T00:00:00",
        "month": "Aug 2024",
        "dailyUsersCount": 2177,
        "weeklyUsersCount": 4823,
        "monthlyUsersCount": 1077
    },
    {
        "dateInstance": "2024-05-01T00:00:00",
        "month": "May 2024",
        "dailyUsersCount": 1632,
        "weeklyUsersCount": 3813,
        "monthlyUsersCount": 1024
    },
    {
        "dateInstance": "2024-09-01T00:00:00",
        "month": "Sep 2024",
        "dailyUsersCount": 24,
        "weeklyUsersCount": 2021,
        "monthlyUsersCount": 834
    },
    {
        "dateInstance": "2024-07-01T00:00:00",
        "month": "Jul 2024",
        "dailyUsersCount": 1645,
        "weeklyUsersCount": 4979,
        "monthlyUsersCount": 1241
    },
    {
        "dateInstance": "2024-04-01T00:00:00",
        "month": "Apr 2024",
        "dailyUsersCount": 1682,
        "weeklyUsersCount": 3938,
        "monthlyUsersCount": 1026
    },
    {
        "dateInstance": "2024-06-01T00:00:00",
        "month": "Jun 2024",
        "dailyUsersCount": 1264,
        "weeklyUsersCount": 3722,
        "monthlyUsersCount": 959
    }
];

const testMonthCounts = [
    {
        "month": "2024-09",
        "uniqueUsers": 1939
    },
    {
        "month": "2024-08",
        "uniqueUsers": 2867
    },
    {
        "month": "2024-07",
        "uniqueUsers": 3080
    },
    {
        "month": "2024-06",
        "uniqueUsers": 2313
    },
    {
        "month": "2024-05",
        "uniqueUsers": 2467
    },
    {
        "month": "2024-04",
        "uniqueUsers": 2510
    },
    {
        "month": "2024-03",
        "uniqueUsers": 1764
    }
];

const testWeekCounts = [
    {
        "week": "2024-09-16T00:00:00",
        "uniqueUsers": 304
    },
    {
        "week": "2024-09-09T00:00:00",
        "uniqueUsers": 1247
    },
    {
        "week": "2024-09-02T00:00:00",
        "uniqueUsers": 1266
    },
    {
        "week": "2024-08-26T00:00:00",
        "uniqueUsers": 1340
    },
    {
        "week": "2024-08-19T00:00:00",
        "uniqueUsers": 1552
    },
    {
        "week": "2024-08-12T00:00:00",
        "uniqueUsers": 1279
    },
    {
        "week": "2024-08-05T00:00:00",
        "uniqueUsers": 1202
    },
    {
        "week": "2024-07-29T00:00:00",
        "uniqueUsers": 1558
    },
    {
        "week": "2024-07-22T00:00:00",
        "uniqueUsers": 1361
    },
    {
        "week": "2024-07-15T00:00:00",
        "uniqueUsers": 1122
    },
    {
        "week": "2024-07-08T00:00:00",
        "uniqueUsers": 1196
    },
    {
        "week": "2024-07-01T00:00:00",
        "uniqueUsers": 1285
    },
    {
        "week": "2024-06-24T00:00:00",
        "uniqueUsers": 1306
    },
    {
        "week": "2024-06-17T00:00:00",
        "uniqueUsers": 1147
    },
    {
        "week": "2024-06-10T00:00:00",
        "uniqueUsers": 852
    },
    {
        "week": "2024-06-03T00:00:00",
        "uniqueUsers": 1004
    },
    {
        "week": "2024-05-27T00:00:00",
        "uniqueUsers": 1109
    },
    {
        "week": "2024-05-20T00:00:00",
        "uniqueUsers": 1017
    },
    {
        "week": "2024-05-13T00:00:00",
        "uniqueUsers": 1032
    }
];

const testDailyCounts = [

]

const testDailyCountsOld = [
    {
        "day": "2024-08-01T00:00:00",
        "uniqueUsers": 368
    },
    {
        "day": "2024-08-02T00:00:00",
        "uniqueUsers": 297
    },
    {
        "day": "2024-08-03T00:00:00",
        "uniqueUsers": 42
    },
    {
        "day": "2024-08-04T00:00:00",
        "uniqueUsers": 124
    },
    {
        "day": "2024-08-05T00:00:00",
        "uniqueUsers": 450
    },
    {
        "day": "2024-08-06T00:00:00",
        "uniqueUsers": 356
    },
    {
        "day": "2024-08-07T00:00:00",
        "uniqueUsers": 336
    },
    {
        "day": "2024-08-08T00:00:00",
        "uniqueUsers": 268
    },
    {
        "day": "2024-08-09T00:00:00",
        "uniqueUsers": 284
    },
    {
        "day": "2024-08-10T00:00:00",
        "uniqueUsers": 53
    },
    {
        "day": "2024-08-11T00:00:00",
        "uniqueUsers": 88
    },
    {
        "day": "2024-08-12T00:00:00",
        "uniqueUsers": 559
    },
    {
        "day": "2024-08-13T00:00:00",
        "uniqueUsers": 387
    },
    {
        "day": "2024-08-14T00:00:00",
        "uniqueUsers": 340
    },
    {
        "day": "2024-08-15T00:00:00",
        "uniqueUsers": 287
    },
    {
        "day": "2024-08-16T00:00:00",
        "uniqueUsers": 231
    },
    {
        "day": "2024-08-17T00:00:00",
        "uniqueUsers": 38
    },
    {
        "day": "2024-08-18T00:00:00",
        "uniqueUsers": 100
    },
    {
        "day": "2024-08-19T00:00:00",
        "uniqueUsers": 522
    },
    {
        "day": "2024-08-20T00:00:00",
        "uniqueUsers": 362
    },
    {
        "day": "2024-08-21T00:00:00",
        "uniqueUsers": 520
    },
    {
        "day": "2024-08-22T00:00:00",
        "uniqueUsers": 527
    },
    {
        "day": "2024-08-23T00:00:00",
        "uniqueUsers": 389
    },
    {
        "day": "2024-08-24T00:00:00",
        "uniqueUsers": 73
    },
    {
        "day": "2024-08-25T00:00:00",
        "uniqueUsers": 138
    },
    {
        "day": "2024-08-26T00:00:00",
        "uniqueUsers": 642
    },
    {
        "day": "2024-08-27T00:00:00",
        "uniqueUsers": 443
    },
    {
        "day": "2024-08-28T00:00:00",
        "uniqueUsers": 252
    },
    {
        "day": "2024-08-29T00:00:00",
        "uniqueUsers": 349
    },
    {
        "day": "2024-08-30T00:00:00",
        "uniqueUsers": 260
    },
    {
        "day": "2024-08-31T00:00:00",
        "uniqueUsers": 52
    }
];

// const testCountsAll = [
//     {
//         "day": "2024-09-05T00:00:00",
//         "userCount": 420,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-30T00:00:00",
//         "userCount": 424,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-04-29T00:00:00",
//         "userCount": 1160,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-17T00:00:00",
//         "userCount": 394,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-08-19T00:00:00",
//         "userCount": 1552,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-03T00:00:00",
//         "userCount": 526,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-19T00:00:00",
//         "userCount": 589,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-07-01T00:00:00",
//         "userCount": 1285,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-28T00:00:00",
//         "userCount": 58,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-16T00:00:00",
//         "userCount": 371,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-08-01T00:00:00",
//         "userCount": 2867,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-06-01T00:00:00",
//         "userCount": 2313,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-09-04T00:00:00",
//         "userCount": 394,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-05-20T00:00:00",
//         "userCount": 1017,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-25T00:00:00",
//         "userCount": 341,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-18T00:00:00",
//         "userCount": 356,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-04-01T00:00:00",
//         "userCount": 1789,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-09-29T00:00:00",
//         "userCount": 97,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-08-26T00:00:00",
//         "userCount": 1340,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-15T00:00:00",
//         "userCount": 59,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-07-15T00:00:00",
//         "userCount": 1122,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-07-29T00:00:00",
//         "userCount": 1558,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-24T00:00:00",
//         "userCount": 387,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-21T00:00:00",
//         "userCount": 73,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-06T00:00:00",
//         "userCount": 282,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-05-13T00:00:00",
//         "userCount": 1032,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-10-07T00:00:00",
//         "userCount": 1163,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-07-08T00:00:00",
//         "userCount": 1196,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-02T00:00:00",
//         "userCount": 244,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-01T00:00:00",
//         "userCount": 2850,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-05-01T00:00:00",
//         "userCount": 2467,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-09-13T00:00:00",
//         "userCount": 307,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-07T00:00:00",
//         "userCount": 48,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-08T00:00:00",
//         "userCount": 104,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-04-15T00:00:00",
//         "userCount": 819,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-05-27T00:00:00",
//         "userCount": 1109,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-07-01T00:00:00",
//         "userCount": 3080,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-09-09T00:00:00",
//         "userCount": 1247,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-14T00:00:00",
//         "userCount": 55,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-20T00:00:00",
//         "userCount": 391,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-01T00:00:00",
//         "userCount": 91,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-07-22T00:00:00",
//         "userCount": 1361,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-23T00:00:00",
//         "userCount": 1293,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-04-22T00:00:00",
//         "userCount": 1161,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-12T00:00:00",
//         "userCount": 324,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-30T00:00:00",
//         "userCount": 1217,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-06-17T00:00:00",
//         "userCount": 1147,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-10-14T00:00:00",
//         "userCount": 436,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-06-24T00:00:00",
//         "userCount": 1306,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-11T00:00:00",
//         "userCount": 369,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-10T00:00:00",
//         "userCount": 433,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-08-05T00:00:00",
//         "userCount": 1202,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-09T00:00:00",
//         "userCount": 509,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-06-10T00:00:00",
//         "userCount": 852,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-22T00:00:00",
//         "userCount": 126,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-26T00:00:00",
//         "userCount": 306,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-08-12T00:00:00",
//         "userCount": 1279,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-02T00:00:00",
//         "userCount": 1266,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-27T00:00:00",
//         "userCount": 267,
//         "resultType": "daily"
//     },
//     {
//         "day": "2024-09-16T00:00:00",
//         "userCount": 1489,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-06-03T00:00:00",
//         "userCount": 1004,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-10-01T00:00:00",
//         "userCount": 1792,
//         "resultType": "monthly"
//     },
//     {
//         "day": "2024-05-06T00:00:00",
//         "userCount": 1112,
//         "resultType": "weekly"
//     },
//     {
//         "day": "2024-09-23T00:00:00",
//         "userCount": 572,
//         "resultType": "daily"
//     }
// ];



export const uniqueUsersCountFilterSelected = (filter) => {
    //return an action
    return {
        type: 'UNIQUE_USERS_COUNT_FILTER_SELECTED',
        payload: filter
    };
};


//initial function to get data
export const fetchUniqueUserstData = (userToken) => async dispatch => {
    //start loading spinner, update state to start showwing loading spinner
    dispatch({ type: 'UNIQUE_USER_COUNTS_IS_LOADING' });

    //API Call to return unique user data
    let responseData = await getDataCall(userToken);

    let dailyList = responseData.filter(item => item.resultType === "daily");
    let weeklyList = responseData.filter(item => item.resultType === "weekly");
    let monthlyList = responseData.filter(item => item.resultType === "monthly");

    // let dailyList = testCountsAll.filter(item => item.resultType === "daily");
    // let weeklyList = testCountsAll.filter(item => item.resultType === "weekly");
    // let monthlyList = testCountsAll.filter(item => item.resultType === "monthly");


    let allCountsObj = {
        "MonthCounts": monthlyList,
        "WeekCounts": weeklyList,
        "DailyCounts": dailyList
    }

    //reverse arrays to get them in ascending order
    // allCountsObj.WeekCounts.reverse();
    // allCountsObj.MonthCounts.reverse();

    //Keep only the date and remove everything after
    allCountsObj.DailyCounts = await allCountsObj.DailyCounts.map(obj => ({
        ...obj,
        day: obj.day.split('T')[0]
    }));

    allCountsObj.WeekCounts = await allCountsObj.WeekCounts.map(obj => ({
        ...obj,
        day: obj.day.split('T')[0]
    }));

    allCountsObj.MonthCounts = await allCountsObj.MonthCounts.map(obj => ({
        ...obj,
        day: obj.day.split('T')[0]
    }));


    //order all arrays in ascending order using the day attribute
    allCountsObj.DailyCounts.sort((a, b) => new Date(a.day) - new Date(b.day));
    allCountsObj.WeekCounts.sort((a, b) => new Date(a.day) - new Date(b.day));
    allCountsObj.MonthCounts.sort((a, b) => new Date(a.day) - new Date(b.day));

    //keep only last quarter 3 months worth of weeks (12 weeks +1 includes current week)
    allCountsObj.WeekCounts = allCountsObj.WeekCounts.slice(-13);

    //remove Month first index
    allCountsObj.MonthCounts.shift();


    let uniqueUsersCounts = allCountsObj; //test this

    console.log("Unique Users Counts: ", uniqueUsersCounts);

    //call data clean up function
    // let finalUsersCounts = await cleanUpData(uniqueUsersCounts);

    // console.log("Unique Users cleaned Counts: ", finalUsersCounts);

    //update state to send back final clean data to show in bar graph
    dispatch({ type: 'FETCH_UNIQUE_USERS_COUNTS_DATA', payload: uniqueUsersCounts });

    //update state data to stop showing loading spinner
    dispatch({ type: 'UNIQUE_USERS_COUNTS_IS_READY' });
};

//data manipulation to format data from API call
const cleanUpData = async (data) => {

    //keep only the month abbreviation for example "Jan"
    data.forEach(obj => {
        //keep only the abbreviation part
        const monthAbbreviation = obj.month.split(' ')[0];
        obj.month = monthAbbreviation;

        //sum up Month, Weekly, and Daily counts to equal total monthly users
        obj.monthlyUsersCount = (obj.monthlyUsersCount ?? 0) + (obj.weeklyUsersCount ?? 0) + (obj.dailyUsersCount ?? 0);
    });

    //sort by months ascending to show in bar graph showing later months on the left to current months on the right
    data.sort((a, b) => new Date(a.dateInstance) - new Date(b.dateInstance));


    //return clean data array
    return data;
}


//API Call to get Unique user counts for past months
const getDataCall = async (curToken) => {
    try {

        // Define the base URL and endpoint
        const baseUrl = process.env.REACT_APP_BASE_URL + "/Analytics/UniqueUsersCount";

        // Define headers
        const headers = {
            'Authorization': 'Bearer ' + curToken.accessToken,
        };

        // Define query parameters
        const params = {
            platform: 'desktop'
        };

        // Make GET request 
        const response = await axios.get(baseUrl, {
            headers: headers,
            params: params
        });

        console.log("Unique User's Counts API Response:", response.data);
        return response.data;
        //return testCountsAll;
        //dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
    } catch (error) {
        // Handle any errors
        console.log("Error getting Unique Users Counts from API:");
        return [];
    }
}